/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, MenuItem, FormControl, Select, InputLabel, Input, Checkbox, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { convertToArray, getRanksForCustomSplitCandidates } from '../../../helpers/pricing';

const styles = makeStyles({
  formControl: {
    width: '140px',
  },
  splitContainer: {
    marginTop: '15px',
  },
});

const customSplitItemCount = customSplit => {
  if (!customSplit) return 0;
  if (Array.isArray(customSplit)) return customSplit.length;
  try {
    const parsed = JSON.parse(customSplit);
    return Array.isArray(parsed) ? parsed.length : 0;
  } catch {
    return 0;
  }
};

const CustomSplit = props => {
  const { group, handleGroupAttrEdit, quantity } = props;
  const classes = styles();
  const quantityArray = Array.from({ length: quantity }, (_, i) => i + 1);

  const getCustomSplit = () => {
    if (group.custom_split) {
      return convertToArray(group.custom_split, quantityArray);
    }
    if (group.ranks && group.ranks.length > 0) {
      const candidates = getRanksForCustomSplitCandidates(group.ranks);
      if (candidates.length === 0) {
        return [];
      }
      const rankWithLongestSplit = candidates.reduce((best, rank) =>
        customSplitItemCount(rank.custom_split) > customSplitItemCount(best.custom_split) ? rank : best
      );
      return convertToArray(rankWithLongestSplit.custom_split, quantityArray);
    }
    return [];
  };

  const customSplit = getCustomSplit();

  return (
    <>
      <Grid item xs={12} className={classes.splitContainer}>
        <FormControl className={classes.formControl} error={quantityArray.length === 0}>
          <InputLabel shrink htmlFor="age-simple">
            Custom Split
          </InputLabel>

          <Select
            multiple
            value={customSplit}
            onChange={handleGroupAttrEdit('custom_split', null)}
            input={<Input width={100} id="select-multiple-custom-splits" />}
            renderValue={selected => {
              const vals = Array.isArray(selected) ? selected : [];
              return vals
                .slice()
                .sort((a, b) => a - b)
                .join(', ');
            }}
          >
            {quantityArray.map(split => (
              <MenuItem key={split} value={split}>
                <Checkbox checked={customSplit.includes(split)} />
                <ListItemText primary={split} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
};

CustomSplit.propTypes = {
  group: PropTypes.object.isRequired,
  handleGroupAttrEdit: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
};

export default CustomSplit;
